import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 64,
    flexGrow: 1,
  },
  header: {
    minHeight: 80,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    alignItems: 'center',
    margin: 16,
    marginTop: 32,
    padding: 8,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#C4C6C9',
    borderRadius: 16,
  },
  content: {
    display: 'flex',
    flex: 1,
  },
  grid: {
    padding: 8,
  },
  sectionContainer: {
    minHeight: 680,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#C4C6C9',
    borderRadius: 16,
    overflow: 'hidden',
    marginBottom: 16,
  },
  sectionTitleContainer: {
    height: 56,
    position: 'relative',
    top: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    overflow: 'hidden',
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: theme.palette.common.white,
    textTransform: 'uppercase',
  },
  sectionButton: {
    position: 'absolute',
    right: 16,
  },
  sectionContent: {
    margin: 8,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  lastSectionTitle: {
    marginBottom: 8,
    alignSelf: 'center',
    textAlign: 'center',
    textTransform: 'uppercase',
    fontWeight: 700,
    fontSize: 18,
  },
  rankingContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  rankingCharts: {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  rankingContent: {
    // height: '100%',
    height: 160,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    marginBottom: 8,
  },
  qualityImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  title: {
    fontSize: 18,
    fontWeight: 700,
    textTransform: 'uppercase',
    textAlign: 'center',
  },
}));
